import React from 'react'
import PropTypes from 'prop-types'
import { Rating } from '@sainsburys-tech/fable'

const Ratings = ({ onClickHandler, overallRating, reviewCount }) => {
  return (
    <button type='button' data-testid='reviews-flag' onClick={onClickHandler}>
      <Rating rating={overallRating}>
        <span onClick={onClickHandler} data-testid='reviews-flag-link'>
          ({reviewCount})
        </span>
      </Rating>
    </button>
  )
}
export default Ratings

Ratings.propTypes = {
  onClickHandler: PropTypes.func.isRequired,
  overallRating: PropTypes.number.isRequired,
  reviewCount: PropTypes.number.isRequired
}
